"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeUnknownError = exports.serializeError = void 0;
const effect_1 = require("effect");
const ParseErrorFormatter = __importStar(require("./parse-error-formatter"));
// A ParseError's `stack` is `ParseError: <multi-KB tree>\n    at <frame>...`.
// The tree is the noise we're stripping; the call frames still locate where the
// decode failed, so keep them and drop only the dumped message.
const stackFrames = (error) => (error.stack ?? '')
    .split('\n')
    .filter(line => line.trimStart().startsWith('at '))
    .join('\n');
/**
 * Serialize an error to a plain JavaScript object
 */
const serializeError = (error) => {
    if (effect_1.ParseResult.isParseError(error)) {
        const issues = ParseErrorFormatter.formatErrorLines(error);
        const frames = stackFrames(error);
        const stack = `${error.name}: schema decode failed`;
        return {
            message: `Schema decode failed (${issues.length} issue(s))`,
            kind: error.name,
            stack: frames ? `${stack}\n${frames}` : stack,
            issues,
            cause: undefined,
        };
    }
    const cause = effect_1.Runtime.isFiberFailure(error)
        ? effect_1.Cause.squash(error[effect_1.Runtime.FiberFailureCauseId])
        : error.cause;
    return {
        message: error.message,
        stack: error.stack ?? `${error.name}: ${error.message}`,
        kind: error.name,
        cause: cause ? (0, exports.serializeUnknownError)(cause) : undefined,
    };
};
exports.serializeError = serializeError;
/**
 * Treat any value like it's supposed to be an Error, and then serialize it to
 * a plain JavaScript object.
 */
const serializeUnknownError = (value) => {
    // Special treatment for ConfigError because it doesn't extend from Error.
    if (effect_1.ConfigError.isConfigError(value))
        return {
            message: value.message,
            stack: `${value._tag}: ${value.message}`,
            kind: value._tag,
            cause: undefined,
        };
    try {
        const error = value instanceof Error ? value : new Error(`Non-error error: ${JSON.stringify(value)}`);
        return (0, exports.serializeError)(error);
    }
    catch (cause) {
        const error = new Error('Error occurred while trying to serialize a non-error', { cause });
        return (0, exports.serializeError)(error);
    }
};
exports.serializeUnknownError = serializeUnknownError;
//# sourceMappingURL=err.js.map